import { createStore } from 'satcheljs';
import TrueTimeStore from './schema/TrueTimeStore';
import { State } from './schema/State';

const defaultTrueTimeStore: TrueTimeStore = {
    state: State.Uninitialized,
    mergedViewEnabledAccount: undefined,
};

export const getStore = createStore<TrueTimeStore>('trueTimeStore', defaultTrueTimeStore);

export default getStore;
